export const registerSteps = {
  sendloginCode: 0,
  login: 1,
  signup: 2
};
